module.exports = __webpack_public_path__ + "img/MP4fm.95cd76ec.jpg";